import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(Backend)
  .init({
    backend: {
      loadPath: `/www/locales/{{ns}}.{{lng}}.json?v=${window.templateDefaults.translationVersion}`,
    },
    lng: window.templateDefaults.locale,
    fallbackLng: "en",
    debug: true,
    ns: [
      "messages",
      "clientPanelMisc",
      "youtube",
      "clientPanelVideo",
      "clientPanelInfo",
      "clientPanelStats",
      "clientPanelDownload",
      "clientPanelConstants",
      "customerPortal",
      "clientPanelRansom",
      "plumage",
      "login",
      "address",
      "immersive3dTourPanelMisc",
      "immersive3dTourPanelConstants",
      "billingCentral",
      "constants",
      "greetingBotDefaultValues",
    ],
    defaultNS: "messages",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
